import type { AttendanceVerificationPrintDocument } from '../types';

export type OfficialAttendanceRosterRow = AttendanceVerificationPrintDocument['roster'][number];

/**
 * Formats the status already selected by the canonical official-print snapshot.
 * Filtering remains server-owned; callers must render printDocument.roster as-is.
 */
export function formatOfficialAttendanceStatus(
  row: OfficialAttendanceRosterRow,
  separator = ' — ',
): string {
  if (row.status === 'Checked In') return 'Telah Hadir';

  const reason = row.reason
    ? `${separator}${row.reason}${row.reason_detail ? `: ${row.reason_detail}` : ''}`
    : '';
  return `Tidak Hadir${reason}`;
}
